// First-run setup and login screens.
import { api } from './api.js';
import { clear, h } from './dom.js';
import type { AuthMe } from './types.js';

function field(label: string, input: HTMLInputElement): HTMLElement {
  return h('label', { class: 'field' }, [h('span', { text: label }), input]);
}

/** Renders the setup/login form into `root`; calls `onDone` after a successful auth. */
export function renderAuth(root: HTMLElement, me: AuthMe, onDone: () => void): void {
  const setup = me.setupRequired;
  clear(root);
  const setupToken = h('input', { class: 'text-input', type: 'text', placeholder: 'paste the setup token from the server log' });
  const username = h('input', { class: 'text-input', type: 'text', value: 'admin' });
  const password = h('input', { class: 'text-input', type: 'password', placeholder: 'at least 8 characters' });
  const error = h('p', { class: 'error-text' });
  const submit = h('button', {
    class: 'primary-button',
    text: setup ? 'Create admin account' : 'Sign in',
    type: 'button',
  });

  const submitForm = async (): Promise<void> => {
    error.textContent = '';
    submit.disabled = true;
    try {
      if (setup) await api.setup(setupToken.value.trim(), username.value.trim(), password.value);
      else await api.login(username.value.trim(), password.value);
      onDone();
    } catch (failure) {
      error.textContent = (failure as Error).message;
      submit.disabled = false;
    }
  };

  submit.addEventListener('click', () => void submitForm());
  for (const input of [setupToken, username, password]) {
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') void submitForm();
    });
  }

  root.append(
    h('div', { class: 'auth-screen' }, [
      h('form', { class: 'auth-card' }, [
        h('h1', { text: 'VaultSync' }),
        h('p', { class: 'muted-text', text: setup ? 'First run: create the admin account for this server.' : `Sign in to ${me.vault}` }),
        ...(setup ? [field('Setup token', setupToken)] : []),
        field('Username', username),
        field('Password', password),
        submit,
        error,
      ]),
    ]),
  );
  (setup ? setupToken : username).focus();
}
